// Vendor
import * as React from 'react';

// Internal
import { Image } from '@src/components/Image/Image';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';
import { SlideReveal } from '@src/components/SlideReveal/SlideReveal';

const SecondhandMarketGrowth: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-xl">
        Secondhand Market Set to Hit $64B in the Next 5 Years
      </h1>

      <h2
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 1}
        className="max-w-lg mb-8"
      >
        Resale is expected to overtake the traditional thrift and donation
        segment by 2024.
      </h2>
      <SlideReveal>
        <Image
          {...DEFAULT_SAL_PROPS}
          addLink={true}
          alt="Consumer trends chart"
          fileName="1b-chart.png"
          maxWidth={733}
        />
      </SlideReveal>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 2}
        className="tup-description"
      >
        Market Sizing and Growth Estimates (2020)
      </p>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 3}
        className="tup-source"
      >
        GlobalData Market Sizing and Growth Estimates
      </p>
    </div>
  );
};

export { SecondhandMarketGrowth };
